/**
 * Flavortown Splash Transition
 * CTA click → red splash slides up with random catchphrase → navigates.
 * Navigates as soon as the slide-in animation completes (not on a timer).
 */
(function () {
  'use strict';

  var overlay;
  var splashText;
  var animating = false;

  var PHRASES = [
    'WELCOME TO\nFLAVORTOWN',
    'WINNER WINNER\nCHICKEN DINNER',
    'THAT\'S\nMONEY',
    'TAKING IT TO\nFLAVORTOWN',
    'FUNKALICIOUS',
    'OUT OF\nBOUNDS',
    'BIG FLAVOR\nBIGGER WAGS',
    'WE\'RE ROLLING\nOUT!',
    'SHUT THE\nFRONT DOOR',
    'NOW WE\'RE\nCOOKIN\''
  ];

  function createOverlay() {
    if (document.getElementById('ft-splash-overlay')) return;

    overlay = document.createElement('div');
    overlay.id = 'ft-splash-overlay';
    overlay.className = 'ft-splash-overlay';

    splashText = document.createElement('div');
    splashText.className = 'ft-splash-text';
    overlay.appendChild(splashText);

    document.body.appendChild(overlay);
  }

  function resetState() {
    animating = false;
    if (overlay) {
      overlay.classList.remove('is-active');
    }
  }

  function triggerSplash(href) {
    if (animating) return;
    animating = true;

    var phrase = PHRASES[Math.floor(Math.random() * PHRASES.length)];
    splashText.innerHTML = phrase.replace(/\n/g, '<br>');

    overlay.classList.remove('is-active');
    void overlay.offsetWidth;
    overlay.classList.add('is-active');

    // Navigate when slide-in completes, 1s max
    var navigated = false;
    function navigate() {
      if (navigated) return;
      navigated = true;
      window.location.href = href;
    }

    function onAnimEnd(e) {
      if (e.animationName === 'ft-splash-in') {
        overlay.removeEventListener('animationend', onAnimEnd);
        navigate();
      }
    }
    overlay.addEventListener('animationend', onAnimEnd);

    // Hard cap at 1 second
    setTimeout(navigate, 1000);
  }

  function init() {
    createOverlay();

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) resetState();
    });

    document.addEventListener('click', function (e) {
      if (!document.querySelector('.flavortown-hero')) return;
      if (animating) return;

      var link = e.target.closest('a[href], button[data-href]');
      if (!link) return;

      var href = link.getAttribute('href') || link.getAttribute('data-href');
      if (!href || href === '#' || href.indexOf('javascript:') === 0) return;
      if (link.getAttribute('target') === '_blank') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      triggerSplash(href);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
